module.exports = "https://www.gc-qa.gnp.com.mx/76eee4cc6f3db7a0a4668f0a20038f15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-poliza-vida.svg
// module id = 8086
// module chunks = 0